import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useAxios } from '../../utils/hook/useAxios';

function Switch({ id, label, checked, onChange }) {
  return (
    <label className="mc-switch" htmlFor={id}>
      <input type="checkbox" role="switch" id={id} checked={checked} onChange={onChange} />
      <span className="mc-switch-text">{label}</span>
      <span className="mc-switch-track" aria-hidden="true"></span>
    </label>
  );
}

function AvailabilitiesCar() {
  const [modelId, setModelId] = useState(null);

  const [vehicleData, setVehicleData] = useState({});
  const { voitureId } = useParams();
  const [selectedValue, setSelectedValue] = useState('08:00');
  const [selectedValue2, setSelectedValue2] = useState('20:00');

  // Prix par jour — pré-rempli depuis reservationPrice de l'annonce
  const [reservationPrice, setReservationPrice] = useState('');
  const [announcedPrice, setAnnouncedPrice] = useState(null); // prix enregistré dans l'annonce
  const [priceError, setPriceError] = useState('');
  const [saving, setSaving] = useState(false);

  const axios = useAxios();

  useEffect(() => {
    const load = async () => {
      try {
        // 1. Vehicle data
        const vehResp = await axios.get('/vehicles/searchbyid/' + voitureId);
        if (vehResp.data) {
          setVehicleData(vehResp.data);
          setModelId(vehResp.data.modeleId);
          window.localStorage.setItem('VehicleStorage', JSON.stringify(vehResp.data));
        }

        // 2. Annonce pour récupérer reservationPrice
        const annonceResp = await axios.get('/vehicleAnnonces/getbyvehiculeid/' + voitureId);
        const price = annonceResp.data?.reservationPrice;
        if (price !== undefined && price !== null) {
          const parsed = parseFloat(price);
          if (!isNaN(parsed) && parsed > 0) {
            setReservationPrice(String(parsed));
            setAnnouncedPrice(parsed);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, []);
  // Fonction pour générer les options pour les heures
  const generateHourOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourString = hour.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const minuteString = minute.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const timeString = `${hourString}:${minuteString}`;
        options.push(
          <option key={timeString} value={timeString}>
            {timeString}
          </option>
        );
      }
    }

    return options;
  };

  const handleChange = (e) => setSelectedValue(e.target.value);
  const handleChange2 = (e) => setSelectedValue2(e.target.value);

  const handleReservationPriceChange = (e) => {
    setReservationPrice(e.target.value);
    setPriceError('');
  };

  const [JoursSemaines, setJoursSemaines] = useState(true);
  const [Weekends, setWeekends] = useState(true);

  async function handleAjouterDisponibilites() {
    // Validate price
    const price = parseFloat(reservationPrice);
    if (!reservationPrice || isNaN(price) || price <= 0) {
      setPriceError('Veuillez saisir un prix par jour valide (> 0 €)');
      return;
    }
    if (selectedValue >= selectedValue2) {
      toast.warning("L'heure de fin doit être après l'heure de début");
      return;
    }

    setSaving(true);
    try {
      const days = [...(JoursSemaines ? [0, 1, 2, 3, 4] : []), ...(Weekends ? [5, 6] : [])];

      for (const i of days) {
        await axios.post('/availabilities', {
          vehiculeId: Number(voitureId),
          WeekDAY: i.toString(),
          fromTime: selectedValue,
          untilTime: selectedValue2,
          Type_de_location: '0',
          type: '0',
          Default_price: price,
        });
      }

      // HoteAvailabilities par défaut (08:00–22:00) pour les deux modes
      for (let i = 0; i <= 6; i++) {
        await axios.post('/hoteavailabilities', {
          userId: vehicleData.userId,
          Weekday: i.toString(),
          alwaysAvailable: false,
          startTime: selectedValue,
          endTime: selectedValue2,
          ModeAvailability: '0',
        });
        await axios.post('/hoteavailabilities', {
          userId: vehicleData.userId,
          Weekday: i.toString(),
          alwaysAvailable: false,
          startTime: selectedValue,
          endTime: selectedValue2,
          ModeAvailability: '1',
        });
      }

      toast.success('Disponibilités configurées avec succès !');
      setTimeout(() => {
        window.location.href = '/unavailabilities-car/' + voitureId + '/calendar/0';
      }, 800);
    } catch (err) {
      console.error(err);
      toast.error('Erreur lors de la configuration des disponibilités');
    } finally {
      setSaving(false);
    }
  }

  const noDaySelected = !JoursSemaines && !Weekends;

  return (
    <main className="mc-home mc-form-page">
      <div className="mc-form-shell mc-form-shell--narrow">
        {/* Barre de progression */}
        <div className="mc-stepper">
          <div className="mc-stepper-top">
            <span>Inscrire ma voiture</span>
            <span>80 %</span>
          </div>
          <div
            className="mc-stepper-bar"
            role="progressbar"
            aria-label="Progression de l'inscription"
            aria-valuenow="80"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="mc-stepper-fill" style={{ width: '80%' }}></div>
          </div>
        </div>

        <section className="mc-form-card">
          <span className="mc-section-kicker">DISPONIBILITÉS</span>
          <h1 className="mc-form-title">Disponibilités &amp; prix</h1>
          <p className="mc-form-subtitle">
            Configurez vos créneaux horaires et confirmez le prix par jour.
          </p>

          {/* Jours */}
          <div className="mc-form-block">
            <h3 className="mc-form-section-title mc-block-title">
              <ion-icon name="calendar-outline"></ion-icon>
              Jours disponibles
            </h3>
            <div className="mc-switch-pair">
              <Switch
                id="switchSemaine"
                label="Lun – Ven"
                checked={JoursSemaines}
                onChange={() => setJoursSemaines((v) => !v)}
              />
              <Switch
                id="switchWeekend"
                label="Sam – Dim"
                checked={Weekends}
                onChange={() => setWeekends((v) => !v)}
              />
            </div>
            {noDaySelected && (
              <p className="mc-field-error" role="alert">
                Sélectionnez au moins un groupe de jours.
              </p>
            )}
          </div>

          {/* Horaires */}
          <div className="mc-form-block">
            <h3 className="mc-form-section-title mc-block-title">
              <ion-icon name="time-outline"></ion-icon>
              Plage horaire
            </h3>
            <div className="mc-grid-2 mc-grid-2--tight">
              <div>
                <label className="mc-field-label" htmlFor="heureDebut">
                  Début
                </label>
                <select
                  id="heureDebut"
                  className="mc-select"
                  value={selectedValue}
                  onChange={handleChange}
                >
                  {generateHourOptions()}
                </select>
              </div>
              <div>
                <label className="mc-field-label" htmlFor="heureFin">
                  Fin
                </label>
                <select
                  id="heureFin"
                  className="mc-select"
                  value={selectedValue2}
                  onChange={handleChange2}
                >
                  {generateHourOptions()}
                </select>
              </div>
            </div>
          </div>

          {/* Prix par jour — pré-rempli depuis l'annonce */}
          <div className="mc-form-block">
            <h3 className="mc-form-section-title mc-block-title">
              <ion-icon name="pricetag-outline"></ion-icon>
              Prix par jour
            </h3>

            {announcedPrice !== null && (
              <div className="mc-form-alert mc-form-alert--info mc-form-alert--flush" role="note">
                <ion-icon name="information-circle-outline"></ion-icon>
                <span>
                  Vous avez indiqué <strong>{announcedPrice} €/jour</strong> lors de la création de
                  l'annonce. Confirmez ou modifiez ce prix ci-dessous.
                </span>
              </div>
            )}

            <div className={announcedPrice !== null ? 'mc-field' : ''}>
              <label className="mc-field-label" htmlFor="prixParJour">
                Prix
              </label>
              <div className="mc-input-affix mc-input-affix--wide">
                <input
                  id="prixParJour"
                  type="number"
                  className={`mc-input${priceError ? ' is-invalid' : ''}`}
                  placeholder="ex : 75"
                  min="1"
                  step="0.01"
                  value={reservationPrice}
                  onChange={handleReservationPriceChange}
                  aria-invalid={Boolean(priceError)}
                />
                <span>€ / jour</span>
              </div>
              {priceError && (
                <p className="mc-field-error" role="alert">
                  {priceError}
                </p>
              )}
              <p className="mc-field-hint">
                Ce prix sera appliqué à tous vos créneaux de disponibilité. Vous pourrez l'affiner
                jour par jour depuis <em>Prix &amp; réductions</em>.
              </p>
            </div>
          </div>

          <div className="mc-form-actions">
            <button
              type="button"
              className="mc-btn mc-btn--primary mc-btn--block"
              onClick={handleAjouterDisponibilites}
              disabled={saving || noDaySelected}
            >
              {saving ? (
                <>
                  <span className="mc-spinner" aria-hidden="true"></span>
                  Enregistrement…
                </>
              ) : (
                <>
                  <ion-icon name="checkmark-circle-outline"></ion-icon>
                  Configurer mes disponibilités
                </>
              )}
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}

export default AvailabilitiesCar;
